import React, { useEffect, useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from './Sidebar';
import DailyCollections from './DailyCollections';
import Customers from './Customers';
import Products from './Products';
import CustomerBill from './CustomerBill';
import ProductBill from './ProductBill';
import PrintDayBill from './PrintDayBill';
import CustomerLedger from './CustomerLedger';
import QuickBill from './QuickBill';
import InstantBill from './InstantBill'; // Import the new component
import { getCurrentUser } from '../../services/authService';

const Dashboard = () => {
    const [selectedMenu, setSelectedMenu] = useState(() => {
        try {
            return localStorage.getItem('selectedMenu') || 'collections';
        } catch {
            return 'collections';
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('selectedMenu', selectedMenu);
        } catch {}
    }, [selectedMenu]);

    const user = getCurrentUser();
    const rolesRaw = user?.roles || user?.authorities || user?.permissions || user?.role || [];
    const roles = Array.isArray(rolesRaw)
        ? rolesRaw.map(r => (typeof r === 'string' ? r.toLowerCase() : String(r?.authority || r?.name || '').toLowerCase()))
        : String(rolesRaw).toLowerCase();
    const hasCustomerAccess = Array.isArray(roles)
        ? (roles.includes('admin') || roles.includes('super_user'))
        : (roles.includes('admin') || roles.includes('super_user'));

    const renderContent = () => {
        switch (selectedMenu) {
            case 'collections':
                return <DailyCollections />;
            case 'instantBill': // Add the new case
                return <InstantBill />;
            case 'customerBill':
                return <CustomerBill />;
            case 'quickBill':
                return <QuickBill />;
            case 'productBill':
                return <ProductBill />;
            case 'printDayBill':
                return <PrintDayBill />;
            case 'customerLedger':
                return <CustomerLedger />;
            case 'customers':
                return hasCustomerAccess ? <Customers /> : <DailyCollections />;
            case 'products':
                return <Products />;
            default:
                return <DailyCollections />;
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <CssBaseline />
            <Sidebar selectedMenu={selectedMenu} onMenuSelect={setSelectedMenu} />
            <Box component="main" sx={{ flexGrow: 1, p: 3, overflowY: 'auto' }}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default Dashboard;
